var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3276284Cf9Cdca7F9Bf68C69Cb5A1A8E34371596(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2465 2231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_2002_69)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1232.5,
    cy: 1115.5,
    rx: 548.5,
    ry: 431.5,
    fill: "var(--fill-0, #01C281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_69",
    x: 0,
    y: 0,
    width: 2465,
    height: 2231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 342,
    result: "effect1_foregroundBlur_2002_69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3276284Cf9Cdca7F9Bf68C69Cb5A1A8E34371596);
export default __webpack_public_path__ + "static/media/3276284cf9cdca7f9bf68c69cb5a1a8e34371596.6ed939efcf00ec7d9bb5dabcc7b282f2.svg";
export { ForwardRef as ReactComponent };